// SearchBar.jsx
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import './SearchBar.css';

const SearchBar = ({ onSearch }) => {
    return (
        <div className="search-bar">
            <FaSearch className="search-icon" />
            <input 
                type="text" 
                className="search-input" 
                placeholder="Search contacts..." 
                onChange={(e) => onSearch(e.target.value)} 
            />
        </div>
    );
};

export default SearchBar;
